import styled from 'styled-components';

export default styled.div`
    display: block;
    position: relative;
    font-size: 1.2rem;
    text-align: center;
    margin-top: 1rem;
`;
